import { createDocumentApiClient } from "../lib/apiClient";

const api = createDocumentApiClient();

export const fetchDocuments = () => api.get("/documents");

export const fetchDocumentsByOrganisationId = ({ queryKey }) => {
  const organisationId = queryKey[1];
  return api.get(`/documents/org/${organisationId}`);
};

export const fetchDocumentById = ({ queryKey }) => {
  const documentId = queryKey[1];
  return api.get(`/documents/${documentId}`);
};

export const uploadDocument = (document) => api.post("/upload", document);

export const updateDocument = (documentId, documentData) =>
  api.put(`/documents/${documentId}`, documentData);

export const deleteDocument = (documentId) =>
  api.delete(`/documents/${documentId}`);
